import { createReference, MedplumClient } from '@medplum/core';
import { fetchBot } from '@/services/services';
import { Communication, Patient } from '@medplum/fhirtypes';

export type EnabledTopic = { code: string; display: string };

function getEnabledTopics(comunnications: Communication[]): EnabledTopic[] {
  return comunnications.map((comunnication) => {
    const coding = comunnication.topic?.coding?.[0];
    return {
      code: coding?.code as string,
      display: (coding?.display as string).replace(/thread/gi, '').trim(),
    };
  });
}

export async function getPractitionerEnabledTopics(medplum: MedplumClient, patient: Patient) {
  const communications: Communication[] = await fetchBot(medplum, 'get-chat-message-threads-header', {
    patient: createReference(patient),
  });

  return getEnabledTopics(communications);
}
